module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10230.9f623741.jpg";